<template>
  <div class="registerPage">
    <!-- <div class="homebg">
      <img src="../assets/home/coupons_bg.png" alt />
    </div>-->
    <div class="bigBg">
      <div class="publicBox">
        <div class="yellowArticle">
          <img src="../assets/home/ic_yellow.png" alt />
        </div>
        <div class="publicWhiteBox">
          <div class="publicTitleBox box_c">
            <img src="../assets/home/title_left.png" alt />
            <span v-if="!hasCoupon &&!isGetCoupon">注册领取礼包</span>
            <span v-else-if="hasCoupon &&!isGetCoupon">领取成功</span>
            <span v-else-if="!hasCoupon && isGetCoupon">已领取</span>
            <img src="../assets/home/title_right.png" alt />
          </div>
          <div class="registerBox" v-if="!hasCoupon &&!isGetCoupon">
            <div class="phoneBox box_c">
              <input type="number" v-model="phone" placeholder="您的手机号" @input="getPhone" />
            </div>
            <!-- <div class="codeBox box_cqh">
              <div class="codeInput box_c">
                <input type="input" v-model="code" placeholder="短信验证码" />
              </div>
              <div class="sendBtn box_c" @click="sendCode" v-if="!lodingCode">获取验证码</div>
              <div class="sendBtn box_c loading" v-else>{{s}}s后重获验证码</div>
            </div>-->
            <div class="errorValue">{{errorValue}}</div>
            <div class="registerBtn box_c" @click="getCoupon">立即领取</div>
            <div class="protocalBox txt">
              注册即代表您同意
              <router-link to="/protocal">《飞游云用户协议》</router-link>
            </div>
          </div>
          <div class="hasCouponBox txt" v-else-if="hasCoupon &&!isGetCoupon">
            <img src="../assets/register/coupon_ic_success.png" alt />
            <div class="successVlaue">恭喜您，领券成功！</div>
            <div class="successHint">优惠券已放入您的账户，请前往飞游无人机小程序使用</div>
          </div>
          <div class="hasCouponBox txt" v-else-if="!hasCoupon && isGetCoupon">
            <img src="../assets/register/coupon_ic_success.png" alt />
            <div class="successVlaue">您已领取过优惠券，快去使用吧！</div>
            <div class="successHint">优惠券已放入您的账户，请前往飞游无人机小程序使用</div>
          </div>
        </div>
      </div>
      <div class="publicBox">
        <div class="yellowArticle">
          <img src="../assets/home/ic_yellow.png" alt />
        </div>
        <div class="publicWhiteBox setpBg" style="padding:18px 0px">
          <div class="publicTitleBox box_c">
            <img src="../assets/home/title_left.png" alt />
            <span>简单4步 开启新体验</span>
            <img src="../assets/home/title_right.png" alt />
          </div>
          <div class="stepBox box_h" v-for="(item,index) in stepList" :key="index">
            <div class="stepIcon">
              <img :src="item.icon" alt />
            </div>
            <div class="stepInfo">
              <div class="setpTop">
                <span class="num">{{item.num}}</span>
                <span class="title">{{item.title}}</span>
              </div>
              <div class="stepBottom">{{item.info}}</div>
            </div>
          </div>
          <div class="xian">
            <img src="../assets/register/xian.png" alt />
          </div>
          <div class="miniBox box_cqh">
            <div class="miniTxt">
              <div class="title">前往飞游无人机小程序体验</div>
              <div class="hint">
                <span>长按识别二维码</span>
                <img src="../assets/register/code_ic_point.png" alt />
              </div>
            </div>
            <div class="miniCode">
              <img src="../assets/register/code.jpeg" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var time = null;
let isAli ="";
import { Loading, Toast } from "vant";
import qs from "qs";
export default {
  data() {
    return {
      phone: "",
      code: "", //用户输入的验证码
      codeTrue: "", //真实的短信验证码
      errorValue: "",
      lodingCode: false, //是否正在倒计时
      hasCoupon: false, //是否领取成功
      isGetCoupon: false, //是否已领取
      s: 60,
      miniprogram: false, //是否在微信小程序
      isRequest: true, //防止连续点击
      stepList: [
        {
          num: "01",
          icon: require("../assets/register/register_ic_1.png"),
          title: "挑选商品",
          info: "挑选您心仪的租赁商品,选择对应租期租赁"
        },
        {
          num: "02",
          icon: require("../assets/register/register_ic_2.png"),
          title: "免押下单",
          info: "实名认证,审核通过可减免押金"
        },
        {
          num: "03",
          icon: require("../assets/register/register_ic_3.png"),
          title: "极速发货",
          info: "顺丰包邮,在途不算租期,签收次日开始计算租期"
        },
        {
          num: "04",
          icon: require("../assets/register/register_ic_4.png"),
          title: "收货体验",
          info: "租期结束,归还商品,还可选择续租"
        }
      ]
    };
  },
  methods: {
    getPhone(e) {
      // console.log(e.target.value);
    },
    // 发送验证码
    sendCode() {
      let phone = this.phone;
      // console.log(phone);
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        // Toast('请输入正确的手机号码')
        this.errorValue = "请输入正确的手机号码";
        return false;
      } else {
        this.lodingCode = true;
        this.getCode(phone);
        this.countdown();
      }
    },
    // 倒计时
    countdown() {
      time = setInterval(() => {
        this.s--;
        if (this.s == 0) {
          clearInterval(time);
          this.time = null;
          this.lodingCode = false;
          this.s = 60;
        }
      }, 1000);
    },
    // 获取验证码
    getCode(phone) {
      this.$get("code/send?phone=" + phone).then(res => {
        console.log(res);
        if (res.code == 200) {
          Toast("验证码已发送到您的手机，请注意查收");
        }
      });
    },
    // 立即领取
    getCoupon() {
      if (this.isRequest) {
        this.isRequest = false;
        let data = {
          phone: this.phone,
          type: 2
        };
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          // Toast('请输入正确的手机号码')
          this.errorValue = "请输入正确的手机号码";
          this.isRequest = true;
          return false;
        }
        // if (this.code.trim().length == 0) {
        //   this.errorValue = "请输入验证码";
        //   this.isRequest = true;
        //   return false;
        // }
        Toast.loading("请稍后...");
        this.$post("ticket/user", qs.stringify(data))
          .then(res => {
            this.isRequest = true;
            Toast.clear();
            if (res.code == 200) {
              this.hasCoupon = true;
            } else if (res.code == 500 && res.msg == "用户已领取") {
              this.isGetCoupon = true;
            } else {
              Toast(res.msg);
            }
            console.log(res);
          })
          .catch(err => {
            this.isRequest = true;
            Toast.clear();
            console.log(JSON.parse(err));
          });
      } else {
        Toast("搞慢点~");
      }
    }
  },
  mounted() {
    let that = this;
    // 引入微信分享封装函数
    this.wxApi.wxRegister();
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf('AlipayClient') > -1){
      isAli=true;
    }else{
      isAli=false;
    }
    if (isAli) {
      my.getEnv(function(res) {
        console.log(res);
          if (res.miniprogram) {
            that.miniProgram = true;
          }
      });
    }else{
      document.addEventListener("UniAppJSBridgeReady", function() {
      uni.getEnv(function(res) {
        console.log(res);
        console.log("当前环境：" + JSON.stringify(res));
        if (res.miniprogram) {
          that.miniProgram = true;
        }
      });
    });
    }
  },
  beforeDestroy() {
    clearInterval(time);
    this.time = null;
    this.lodingCode = false;
    this.s = 60;
  },
  destroyed() {
    clearInterval(time);
    this.time = null;
    this.lodingCode = false;
    this.s = 60;
  }
};
</script>

<style scoped lang='scss'>
@import "../common/font/font.css";
.registerPage {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 170px;
  background: url("../assets/home/coupons_bg.png") no-repeat;
  background-size: 100%;
  background-color: #f64841;
  .homebg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bigBg {
    position: relative;
    // top: -87px;
  }
  .publicBox {
    width: 100%;
    padding: 0 11px;
    box-sizing: border-box;
    // margin-bottom: 20px;
    .yellowArticle {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .publicWhiteBox {
      width: calc(100% - 12px);
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      padding: 18px 15px;
      box-sizing: border-box;
      position: relative;
      top: -30px;
      .publicTitleBox {
        width: 100%;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: rgba(254, 36, 47, 1);
        margin-bottom: 25px;
        span {
          margin: 0 5px;
        }
        img {
          width: 14px;
        }
      }
      .registerBox {
        width: 100%;
        .phoneBox {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
          height: 41px;
          background: rgba(232, 232, 232, 1);
          border-radius: 5px;
          margin-bottom: 15px;
          input {
            width: 100%;
            outline: none;
            background: none;
            border: none;
            font-size: 13px;
          }
        }
        .codeBox {
          width: 100%;
          margin-bottom: 5px;
          .codeInput {
            flex: 5;
            padding: 0 15px;
            box-sizing: border-box;
            height: 41px;
            background: rgba(232, 232, 232, 1);
            border-radius: 5px;
            input {
              width: 100%;
              outline: none;
              background: none;
              border: none;
              font-size: 13px;
            }
          }
          .sendBtn {
            flex: 3;
            height: 41px;
            background: rgba(255, 224, 30, 1);
            border-radius: 5px;
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-left: 10px;
          }
          .loading {
            font-size: 12px;
          }
        }
        .errorValue {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 51, 51, 1);
          min-height: 15px;
          margin-bottom: 15px;
        }
        .registerBtn {
          width: 100%;
          height: 45px;
          background: url("../assets/register/btn_register.png") no-repeat;
          background-size: 100%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          padding-bottom: 10px;
          box-sizing: border-box;
          img {
            width: 100%;
          }
        }
        .protocalBox {
          font-size: 11px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          margin: 10px auto;
          span {
            color: #1956ec;
          }
          a:visited {
            color: #1956ec;
          }
          a:link {
            color: #1956ec;
          }
          a:hover {
            color: #1956ec;
          }
        }
      }
      .hasCouponBox {
        width: 100%;
        img {
          width: 87px;
          margin-bottom: 15px;
        }
        .successVlaue {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(254, 36, 47, 1);
          margin-bottom: 20px;
        }
        .successHint {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .stepBox {
        width: 100%;
        margin-bottom: 15px;
        padding: 0 15px;
        box-sizing: border-box;
        padding-bottom: 20px;
        .stepIcon {
          flex: 1;
          max-width: 46px;
          max-height: 46px;
          img {
            width: 100%;
          }
        }
        .stepInfo {
          flex: 4;
          padding-left: 10px;
          box-sizing: border-box;
          .setpTop {
            width: 100%;
            .num {
              font-size: 20px;
              font-family: "number";
              font-weight: 400;
              color: rgba(254, 36, 47, 1);
              margin-right: 3px;
            }
            .title {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
            }
          }
          .stepBottom {
            font-size: 11px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
      .xian {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .miniBox {
        width: 100%;
        // border-top: 1px solid #cccccc;
        padding: 10px 15px;
        box-sizing: border-box;
        .miniTxt {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          .title {
            margin-bottom: 15px;
          }
          .hint {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
          img {
            width: 14px;
            margin-left: 15px;
          }
        }
        .miniCode {
          width: 91px;
          height: 91px;
          margin-left: 20px;
          img {
            width: 100%;
          }
        }
      }
    }
    //     .setpBg{
    //     background-color: #ffffff;
    //       background: url('../assets/register/activity_bg.png') no-repeat;
    //       background-size: cover;

    //   }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/register.vue